<template>
    <div>
        <ul class="fa-ul">
            <li v-for="submittal in listOfSubmittals" v-if="$route.params.submittalID != submittal.id">
                <a :href="getUrl(submittal.id)">
                    <i class="fa-li fa fa-file-o"></i> {{ submittal.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        created() {
            this.getListOfSubmittals(this.project.id);
        },
        methods: {
            getUrl(id){
              return `/submittal-manager/mechanical/${id}/information`
            },
            ...mapActions('mechanical', [
                'getListOfSubmittals'
            ])
        },
        computed: {

            ...mapGetters('mechanical', [
                'listOfSubmittals'
            ])
        },
        props: ['project']
    }
</script>
